// extracted by mini-css-extract-plugin
module.exports = {"section":"_2toe7nYpEJF9-F6SaXw4Fb","col-md-6":"_2yIX3lzAOKZaEmeephi_c6","colMd6":"_2yIX3lzAOKZaEmeephi_c6","block":"_2P5-rwVbfOy0-pVBinuf6w"};